module.exports = __webpack_public_path__ + "static/media/galdinsWon_50_75.739f68a3.png";